import { Loader2 } from "lucide-react"
import { cn } from "@/shared/lib/utils"

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg"
  className?: string
}

/**
 * Modern loading spinner using lucide-react icon
 * Follows shadcn/ui patterns
 */
export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  }

  return (
    <Loader2
      className={cn("animate-spin text-primary", sizeClasses[size], className)}
    />
  )
}

interface PageLoadingProps {
  message?: string
  className?: string
}

/**
 * Full-page loading state with message
 * Used for top-level page loads
 */
export function PageLoading({ message = "Loading...", className }: PageLoadingProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center min-h-[400px] gap-4", className)}>
      <LoadingSpinner size="lg" />
      <p className="font-roboto text-sm text-gray-600 animate-pulse">{message}</p>
    </div>
  )
}

/**
 * Inline loading state for sections
 * More compact than PageLoading
 * Fades in after a short delay to prevent flash on quick loads
 */
export function SectionLoading({ message }: PageLoadingProps) {
  return (
    <div className="flex items-center justify-center py-12 gap-3 animate-fade-in-delayed">
      <LoadingSpinner size="md" />
      {message && <p className="font-roboto text-sm text-gray-600">{message}</p>}
    </div>
  )
}
